







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import GlobalBody from "@/components/GlobalBody.vue";
@Component({
  components: {GlobalHeader, GlobalBody}
})
export default class Home extends Vue {}
